import * as Yup from "yup";

export const defaultSteps = [
  {
    id: "bookingForm",
    fields: ["time", "gate"],
  },
  {
    id: "requested",
    fields: [],
  },
  {
    id: "cancelled",
    fields: [],
  },
];

export interface FormFields extends Yup.InferType<typeof schema> {}

// validations
export const schema = Yup.object().shape({
  // booking form
  name: Yup.string().required("Required"),
  mobileNumber: Yup.string()
    .required("Required")
    .matches(/^[0-9]+$/, "MobileNumberEnglishDigitsOnly") // Ensures only English digits
    .matches(/^5\d{8}$/, "MobileNumber9digitsStartWith5"),
  arrivingDate: Yup.date().required("Required"),
  arrivingTime: Yup.date().required("Required"),
});
